import { AccessRightCodes } from "Components/Models/AccessRights";
import { RootStateType } from "State/Store";
import { useSelector } from "react-redux";

export function useHasCurrentUserAccessRight() {
  const userAccessRights = useSelector(
    (state: RootStateType) => state.auth.user?.accessRightCodes,
  );

  const checkAccess = (accessRights: AccessRightCodes[]) => {
    return userAccessRights?.some(
      x =>
        x === AccessRightCodes.SysAdmin_All || accessRights.some(y => y === x),
    );
  };

  return checkAccess;
}

export function necessaryAccessRightEditForCompanies(
  isCustomer: boolean | undefined,
  isSupplier: boolean | undefined,
  isMarketplaceEnabled: boolean | undefined,
) {
  if (
    isCustomer !== undefined &&
    isSupplier !== undefined &&
    isMarketplaceEnabled !== undefined
  ) {
    if (isCustomer && !(isSupplier || isMarketplaceEnabled)) {
      return [AccessRightCodes.Core_Company_Customer_Edit];
    } else if ((isSupplier || isMarketplaceEnabled) && !isCustomer) {
      return [AccessRightCodes.Core_Company_Supplier_Edit];
    }
  }
  return [
    AccessRightCodes.Core_Company_Customer_Edit,
    AccessRightCodes.Core_Company_Supplier_Edit,
  ];
}
